export const getUserEditPath = (userId: string): string => {
  return `/users/edit/${userId}`
}